import { createSelector } from 'reselect';

const selectTransporters = (state: any) => state.transporters;


export const selectTransportersCurrentItem = createSelector([selectTransporters], (transporters) => transporters.current);

export const selectTransportersListItems = createSelector([selectTransporters], (transporters) => transporters.list);

export const selectTransportersItemById = (itemId: any) =>
    createSelector(selectTransportersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTransportersQueryItems = createSelector([selectTransporters], (transporters) => transporters.query);

export const selectTransportersCreatedItem = createSelector([selectTransporters], (transporters) => transporters.create);

export const selectTransportersUpdatedItem = createSelector([selectTransporters], (transporters) => transporters.update);

export const selectTransportersReadItem = createSelector([selectTransporters], (transporters) => transporters.read);

export const selectTransportersDeletedItem = createSelector([selectTransporters], (transporters) => transporters.delete);

export const selectTransportersSearchedItems = createSelector([selectTransporters], (transporters) => transporters.search);

export const selectTransportersItemsCount = createSelector([selectTransporters], (transporters) => transporters.count);

export const selectTransportersItemsFilter = createSelector([selectTransporters], (transporters) => transporters.filter);